import React, { useEffect } from 'react';
import '../styles/Hero.css';
import HeroMascot from '../assets/Hero-Mascot.png';

const Hero = () => {
    useEffect(() => {
        const heroContent = document.querySelector('.hero-content');
        const heroImage = document.querySelector('.hero-image');

        setTimeout(() => {
            heroContent.classList.add('fade-in');
            heroImage.classList.add('fade-in');
        }, 200);
    }, []);

    return (
        <section id='hero' className="hero-section">
            <div className="hero-image">
                <img src={HeroMascot} alt="Ilustrasi Hero" />
            </div>
            <div className="hero-content">
                <h1>Saling Jaga <span className="highlight">Brawijaya</span></h1>
                <p>
                    adalah platform yang dirancang untuk memudahkan dan mengamankan proses pelaporan kekerasan seksual bagi mahasiswa Universitas Brawijaya.
                    Dengan tujuan memberikan ruang aman, mempercepat proses pelaporan, menjamin privasi, dan mendukung penyintas.
                </p>
            </div>
        </section>
    );
};

export default Hero;
